import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context';
import AuthModal from '../components/AuthModal';

// Registracija kaip pilnas puslapis (ne popup).
export default function RegisterPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  return <AuthModal asPage initialTab="register" onClose={() => navigate('/')} />;
}
